// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets//images/product/vision.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets//images/product/mission.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.vision_visionBox__pR5nv {
  width:100%;
  display: flex;
  flex-direction: row;
  height: 500px;
}
.vision_visionContectBox__\\+U6LL{
  background-color: rgb(94, 194, 214);
  padding: 100px;
  width: 50%;
  position: relative;
}


@keyframes vision_testMove__kkK8m {
  from {
    opacity: 0;
    transform: translate3d(0, 20px, 0);
}
to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
}

}
.vision_visionMisionHeader__hCZmx{
  font-weight: 800;
  
}
.vision_visionImgCom__wHHlO{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.vision_missionImgCom__dnTa9{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.vision_visionImgCom__wHHlO , .vision_missionImgCom__dnTa9{
  height: 100%;
  width: 50%;
  background-size: cover;
  background-repeat: no-repeat;
}
.vision_visionContectBoxMobile__IdKAk{
  visibility: hidden;
}



@media (max-width:1024px){
  .vision_visionBox__pR5nv {
    height: 400px;
  }
  .vision_visionContectBox__\\+U6LL{
    padding: 50px;

  }
  .vision_visionMisionHeader__hCZmx{
    font-size: 28px;
    font-weight: 800;
    
  }
  .vision_visionMisionBody__9Vubx{
    font-size: 14px;
  }
}
@media (max-width:770px){
  .vision_visionContectBoxMobile__IdKAk{
    visibility: visible;
    background-color: rgba(242, 245, 247, 0.505);
    width: 75%;
    text-align: center;
    padding: 20px;
  }
  .vision_visionContectBox__\\+U6LL{
    display: none;
  }
  .vision_missionImgCom__dnTa9 , .vision_visionImgCom__wHHlO{
    width: 100vw;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
  }
}
@media (max-width:480px){
  .vision_visionContectBox__\\+U6LL{
    padding: 20px;
  }
  .vision_visionBox__pR5nv {
    height: 250px;
  }

  .vision_visionContectBox__\\+U6LL{
    padding: 20px;

  }
  .vision_visionMisionHeader__hCZmx{
    font-size: 16px;
    font-weight: 600;
    
  }
  .vision_visionMisionBody__9Vubx{
    font-size: 11px;
  }
  .vision_visionContectBoxMobile__IdKAk{
    width: 80%;
    padding: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/aboutUs/vision.module.css"],"names":[],"mappings":";AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,mCAAmC;EACnC,cAAc;EACd,UAAU;EACV,kBAAkB;AACpB;;;AAGA;EACE;IACE,UAAU;IACV,kCAAkC;AACtC;AACA;IACI,UAAU;IACV,+BAA+B;AACnC;;AAEA;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,yDAAgE;AAClE;AACA;EACE,yDAAiE;AACnE;AACA;EACE,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,kBAAkB;AACpB;;;;AAIA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;;EAEf;EACA;IACE,eAAe;IACf,gBAAgB;;EAElB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,mBAAmB;IACnB,4CAA4C;IAC5C,UAAU;IACV,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;EACzB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;;EAEf;EACA;IACE,eAAe;IACf,gBAAgB;;EAElB;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;IACV,aAAa;EACf;AACF","sourcesContent":["\r\n.visionBox {\r\n  width:100%;\r\n  display: flex;\r\n  flex-direction: row;\r\n  height: 500px;\r\n}\r\n.visionContectBox{\r\n  background-color: rgb(94, 194, 214);\r\n  padding: 100px;\r\n  width: 50%;\r\n  position: relative;\r\n}\r\n\r\n\r\n@keyframes testMove {\r\n  from {\r\n    opacity: 0;\r\n    transform: translate3d(0, 20px, 0);\r\n}\r\nto {\r\n    opacity: 1;\r\n    transform: translate3d(0, 0, 0);\r\n}\r\n\r\n}\r\n.visionMisionHeader{\r\n  font-weight: 800;\r\n  \r\n}\r\n.visionImgCom{\r\n  background-image: url('../../assets//images/product/vision.jpg');\r\n}\r\n.missionImgCom{\r\n  background-image: url('../../assets//images/product/mission.jpg');\r\n}\r\n.visionImgCom , .missionImgCom{\r\n  height: 100%;\r\n  width: 50%;\r\n  background-size: cover;\r\n  background-repeat: no-repeat;\r\n}\r\n.visionContectBoxMobile{\r\n  visibility: hidden;\r\n}\r\n\r\n\r\n\r\n@media (max-width:1024px){\r\n  .visionBox {\r\n    height: 400px;\r\n  }\r\n  .visionContectBox{\r\n    padding: 50px;\r\n\r\n  }\r\n  .visionMisionHeader{\r\n    font-size: 28px;\r\n    font-weight: 800;\r\n    \r\n  }\r\n  .visionMisionBody{\r\n    font-size: 14px;\r\n  }\r\n}\r\n@media (max-width:770px){\r\n  .visionContectBoxMobile{\r\n    visibility: visible;\r\n    background-color: rgba(242, 245, 247, 0.505);\r\n    width: 75%;\r\n    text-align: center;\r\n    padding: 20px;\r\n  }\r\n  .visionContectBox{\r\n    display: none;\r\n  }\r\n  .missionImgCom , .visionImgCom{\r\n    width: 100vw;\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n    justify-content: center;\r\n  }\r\n}\r\n@media (max-width:480px){\r\n  .visionContectBox{\r\n    padding: 20px;\r\n  }\r\n  .visionBox {\r\n    height: 250px;\r\n  }\r\n\r\n  .visionContectBox{\r\n    padding: 20px;\r\n\r\n  }\r\n  .visionMisionHeader{\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    \r\n  }\r\n  .visionMisionBody{\r\n    font-size: 11px;\r\n  }\r\n  .visionContectBoxMobile{\r\n    width: 80%;\r\n    padding: 10px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"visionBox": `vision_visionBox__pR5nv`,
	"visionContectBox": `vision_visionContectBox__+U6LL`,
	"visionMisionHeader": `vision_visionMisionHeader__hCZmx`,
	"visionImgCom": `vision_visionImgCom__wHHlO`,
	"missionImgCom": `vision_missionImgCom__dnTa9`,
	"visionContectBoxMobile": `vision_visionContectBoxMobile__IdKAk`,
	"visionMisionBody": `vision_visionMisionBody__9Vubx`,
	"testMove": `vision_testMove__kkK8m`
};
export default ___CSS_LOADER_EXPORT___;
